/**
 * Chat query operations - Delete
 */

import { getSupabaseClient } from '../../supabase-client.js';
import { logger } from '../../../logger.js';

/**
 * Delete a chat and all associated messages
 */
export async function deleteChat(chatId: string): Promise<void> {
  try {
    const client = getSupabaseClient();

    const { error } = await client
      .from('meridian_chats')
      .delete()
      .eq('id', chatId);

    if (error) {
      throw error;
    }
  } catch (error) {
    logger.error('error deleting chat', error, { op: 'deleteChat' });
    throw error;
  }
}
